var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "purchaseItemForReferenceModal",
        "no-close-on-backdrop": "",
        size: "xl",
        centered: "",
        scrollable: "",
      },
      on: { hidden: _vm.onHideModal },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("p", { staticClass: "h4" }, [
                _vm._v(" " + _vm._s(_vm.modalTitle) + " "),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                {
                  staticClass:
                    "w-100 d-flex justify-content-between align-items-center",
                },
                [
                  _c("b-col", [
                    _c("div", [
                      _c("p", { staticClass: "font-weight-bold mb-0" }, [
                        _vm._v(
                          " Itens Selecionados: " +
                            _vm._s(_vm.selectedItemsData.length) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-end gap-2" },
                    [
                      _c("e-button", {
                        attrs: {
                          variant: "secondary",
                          text: _vm.$t("Cancelar"),
                        },
                        on: { click: _vm.onHideModal },
                      }),
                      _c("e-button", {
                        attrs: {
                          variant: "primary",
                          text: _vm.$t("Confirmar"),
                          disabled: _vm.getMissingQuantity > 0,
                          busy: _vm.saving,
                        },
                        on: { click: _vm.onConfirm },
                        scopedSlots: _vm._u([
                          {
                            key: "right-content",
                            fn: function () {
                              return [
                                _vm.getMissingQuantity > 0
                                  ? _c("span", [
                                      _vm._v(
                                        " ( Faltam: " +
                                          _vm._s(_vm.getMissingQuantity) +
                                          " ) "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loadingModal
        ? _c("e-spinner")
        : _c(
            "div",
            [
              _c(
                "e-filters",
                {
                  ref: "filters",
                  staticClass: "mb-3",
                  attrs: { searching: _vm.fetching },
                  on: { search: _vm.onApplyFilters, reset: _vm.onResetFilters },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "purchase_order_id",
                              type: _vm.getFixedPurchaseOrderId
                                ? "label"
                                : "number",
                              label: _vm.$t("Id do pedido"),
                              instruction: _vm.getFixedPurchaseOrderId
                                ? _vm.$t(
                                    "Somente produtos deste pedido de compra podem ser referenciados"
                                  )
                                : "",
                              "router-to": _vm.getFixedPurchaseOrderId
                                ? {
                                    name: "purchase-order-details",
                                    params: {
                                      id: _vm.getFixedPurchaseOrderId,
                                    },
                                  }
                                : null,
                            },
                            model: {
                              value: _vm.filters.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "id", $$v)
                              },
                              expression: "filters.id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("e-person-search", {
                            attrs: {
                              id: "purchase_item_for_reference-supplier_id",
                              label: _vm.$t("Pesquisar fornecedor"),
                              "is-supplier": "",
                              "only-active": false,
                            },
                            model: {
                              value: _vm.filterInputs.supplierId,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterInputs, "supplierId", $$v)
                              },
                              expression: "filterInputs.supplierId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "purchase_item_for_reference-invoice_number",
                              type: "number",
                              label: _vm.$t("Número da nota"),
                            },
                            model: {
                              value: _vm.filterInputs.invoiceNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterInputs, "invoiceNumber", $$v)
                              },
                              expression: "filterInputs.invoiceNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            class: _vm.getFixedPurchaseOrderId
                              ? ""
                              : "required",
                            attrs: {
                              id: "purchase_item_for_reference-invoice_date",
                              type: "date-range-picker",
                              label: _vm.$t("Período da NFe"),
                              "time-picker": false,
                              validation: _vm.getFixedPurchaseOrderId
                                ? ""
                                : "required",
                            },
                            model: {
                              value: _vm.filterInputs.invoiceDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterInputs, "invoiceDate", $$v)
                              },
                              expression: "filterInputs.invoiceDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-card-actions",
                {
                  staticClass: "mb-3",
                  attrs: { "no-actions": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("b-card-title", [
                                _vm._v(" Pedidos de Compras "),
                              ]),
                              _c("e-instructions", {
                                staticClass: "ml-1",
                                attrs: {
                                  id: "purchase_item_for_reference-title_instruction",
                                  instructions: [
                                    {
                                      text: _vm.$t(
                                        "Selecione os itens do pedido de compra que serão referenciados"
                                      ),
                                    },
                                    !_vm.isMultipleOrders
                                      ? {
                                          text: _vm.$t(
                                            "Só é possível referenciar itens de um único pedido de compra; se precisar referenciar outro, será necessário criar outra nota fiscal."
                                          ),
                                        }
                                      : null,
                                  ],
                                  title: _vm.$t("Descrição"),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("e-table-nested-rows", {
                            attrs: {
                              fields: _vm.fields,
                              items: _vm.purchaseOrdersWithSelection,
                              "nested-list-property": "items",
                              "empty-text":
                                "Não foi encontrado produtos para referenciar",
                              fetching: _vm.fetching,
                              "fixed-colapse": true,
                            },
                            on: {
                              "nested-row-click": _vm.onItemSelectionChange,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "detail-cell(itemNumber)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Pedido #" + _vm._s(item.id))]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "detail-cell(productName)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("div", { staticClass: "d-flex gap-3" }, [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("p", { staticClass: "mb-0" }, [
                                            _vm._v(" NFe: "),
                                          ]),
                                          _c("p", { staticClass: "mb-0" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.invoiceKey) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("p", { staticClass: "mb-0" }, [
                                            _vm._v(" Fornecedor: "),
                                          ]),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.supplier.document
                                                  ) +
                                                  " - " +
                                                  _vm._s(item.supplier.name) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "detail-cell(quantityEligibleForReturn)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v(" Data NFe: "),
                                        ]),
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("date")(item.invoiceDate)
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "detail-cell(unitMeasurement)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v(" Data entrada: "),
                                        ]),
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("date")(
                                                  item.completedDate,
                                                  "-"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "nested-cell(itemNumber)",
                                fn: function (ref) {
                                  var item = ref.item
                                  var itemNested = ref.itemNested
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                        on: {
                                          click: function (e) {
                                            return e.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("FormulateInput", {
                                          attrs: {
                                            id:
                                              "purchase_item_for_reference-checkbox_item_" +
                                              itemNested.id,
                                            type: "e-checkbox",
                                            disabled: Boolean(
                                              itemNested.quantityEligibleForReturn <=
                                                0
                                            ),
                                          },
                                          on: {
                                            change: function () {
                                              return _vm.onItemSelectionChange(
                                                item,
                                                itemNested
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.selectedItemsIdMap[
                                                itemNested.id
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.selectedItemsIdMap,
                                                itemNested.id,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selectedItemsIdMap[itemNested.id]",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "#" +
                                                _vm._s(itemNested.itemNumber)
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "nested-cell(productName)",
                                fn: function (ref) {
                                  var itemNested = ref.itemNested
                                  return [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                itemNested.xmlProduct.name ||
                                                  itemNested.erpSku.sku.name
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "nested-cell(quantityEligibleForReturn)",
                                fn: function (ref) {
                                  var itemNested = ref.itemNested
                                  return [
                                    _c(
                                      "p",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("number")(
                                                itemNested.quantityEligibleForReturn ||
                                                  0,
                                                3,
                                                true
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "nested-cell(unitMeasurement)",
                                fn: function (ref) {
                                  var itemNested = ref.itemNested
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              itemNested.erpSku.sku
                                                .unitOfMeasurement
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "nested-cell(cfop)",
                                fn: function (ref) {
                                  var itemNested = ref.itemNested
                                  return [
                                    _vm._v(" " + _vm._s(itemNested.cfop) + " "),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("e-pagination-summary", {
                            attrs: {
                              "current-page": _vm.paging.currentPage,
                              "per-page": _vm.paging.pageSize,
                              total: _vm.paging.rowCount,
                              "total-on-page": _vm.paging.rowsInCurrentPage,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              value: _vm.paging.currentPage,
                              align: "right",
                              "total-rows": _vm.paging.rowCount,
                              "per-page": _vm.paging.pageSize,
                            },
                            on: { change: _vm.pageChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }